<template>
    <div class="global-product-combo" :class="isFirst? 'global-product-combo--with-header': ''">
        <div v-if="isFirst"
             class="global-product-combo__header global-product-combo__set row no-gutters">
            <div class="col-xl-5 col-lg-12 header__part header__part--dst">
                <p class="global-product-combo__product-column global-product-combo__product-column--decor" v-if="!omitDecorColum">
                    {{ $t('global-product-combo.decor') }}<br>
                    {{ $t('global-product-combo.structure') }}
                </p>
                <p class="global-product-combo__product-column global-product-combo__product-column--material" v-if="!omitProductColum">
                    {{ $t('global-product-combo.panel') }}
                </p>
                <p class="global-product-combo__product-column global-product-combo__product-column--material" v-if="!omitRawboardColum">
                    {{ $t('global-product-combo.rawboard') }}
                </p>
            </div>
            <div class="col-xl-7 col-lg-12 header__part header__part--dimension">
                <div class="row no-gutters">
                    <div class="col-md-6 col-xl-8 part--dimension">
                        <p class="global-product-combo__product-column global-product-combo__product-column--application typo-light"
                           v-if="!omitApplicationColumn">
                            {{ $t('global-product-combo.recommended_application') }}
                        </p>
                        <p class="global-product-combo__product-column global-product-combo__product-column--dimensions typo-light">
                            {{ $t('global-product-combo.dimension') }}
                        </p>
                        <p class="global-product-combo__product-column global-product-combo__product-column--delivery-time typo-light">
                            {{ $t('global-product-combo.deliveryTime') }}
                        </p>
                        <p class="global-product-combo__product-column global-product-combo__product-column--action"></p>
                    </div>
                    <div class="col-md-6 col-xl-4 part--action">
                        <div
                            class="global-product-combo__product-column global-product-combo__product-column--action">
                            <slot name="actionHeader"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="global-product-combo__set row no-gutters">
            <div class="col-xl-5 col-lg-12 set__part set__part--dst">
                <div class="global-product-combo__product-column global-product-combo__product-column--decor" v-if="!omitDecorColum">
                    <div class="product-column__label">
                        {{ $t('global-product-combo.decor') }}
                    </div>
                    <template v-if="!product.title_d">
                        &nbsp;
                    </template>
                    <template v-else>
                        <a :href="product.link_d" class="product-column__image">
                            <img
                                :alt="composeAltText([product.title_d, product.titlesuffix_d, product.subtitle_d])"
                                :src="product.image_d_src">
                        </a>
                        <div class="product-column__details">
                            <a :href="product.link_d">
                                <span><strong>{{ product.title_d }}</strong> {{ product.titlesuffix_d }}</span>
                                <span>{{ product.subtitle_d }}</span>
                            </a>
                            <a :href="product.link_s">
                                <span><strong>{{ product.title_s }}</strong> {{ product.titlesuffix_s }}</span>
                            </a>
                        </div>
                    </template>
                </div>
                <div class="global-product-combo__product-column global-product-combo__product-column--material" v-if="!omitProductColum">
                    <div class="product-column__label">
                        {{ $t('global-product-combo.panel') }}
                    </div>
                    <a :href="product.link_t" class="product-column__image">
                        <img
                            :alt="composeAltText([product.title_t, product.titlesuffix_t, product.subtitle_t])"
                            :src="product.image_t_src">
                    </a>
                    <a :href="product.link_t" class="product-column__details">
                        <span><strong>{{ product.title_t }}</strong> {{ product.titlesuffix_t }}</span>
                        <span>{{ product.subtitle_t }}</span>
                    </a>
                </div>
                <div class="global-product-combo__product-column global-product-combo__product-column--material" v-if="!omitRawboardColum">
                    <div class="product-column__label">
                        {{ $t('global-product-combo.rawboard') }}
                    </div>
                    <a :href="product.link_r" class="product-column__image">
                        <img
                            :alt="composeAltText([product.title_r, product.titlesuffix_r, product.subtitle_r])"
                            :src="product.image_r_src">
                    </a>
                    <a :href="product.link_r" class="product-column__details">
                        <span><strong>{{ product.title_r }}</strong> {{ product.titlesuffix_r }}</span>
                        <span>{{ product.subtitle_r }}</span>
                    </a>
                </div>
            </div>
            <div class="col-xl-7 col-lg-12 set__part set__part--dimensions">
                <div class="row no-gutters">
                    <div class="col-md-6 col-xl-8 part--dimension">
                        <div v-if="!omitApplicationColumn" class="global-product-combo__product-column global-product-combo__product-column--application">
                            <div class="small-responsive small-responsive--xs product-column__property">
                                <span class="product-column__label typo-light hidden-xl">{{ $t('global-product-combo.recommended_application') }}</span>
                                <span v-if="product.recommended_application">
                                    <span class="small-responsive small-responsive--xs">
                                        {{ formatApplication(product.recommended_application) }}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div
                            class="global-product-combo__product-column global-product-combo__product-column--dimensions">
                            <span class="small-responsive small-responsive--xs product-column__property">
                                <span class="product-column__label typo-light hidden-xl">{{ $t('global-product-combo.dimension') }}</span>
                                <span>{{ product.format }}&nbsp;x&nbsp;{{ product.height }}<br v-if="product.kante">{{ product.kante }}</span>
                            </span>
                        </div>
                        <div class="global-product-combo__product-column global-product-combo__product-column--delivery-time">
                            <span class="small-responsive small-responsive--xs product-column__property">
                                <span class="product-column__label typo-light hidden-xl">
                                    {{ $t('global-product-combo.deliveryTime') }}
                                </span>
                                <span class='hidden-xl' v-html="product.deliver_l"/>
                                <span class='d-none d-xl-flex delivery-time--desktop'>
                                    <global-tooltip>
                                        <p class='delivery-notice' v-html="product.deliver_l"/>
                                    </global-tooltip>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 part--action">
                        <div class="global-product-combo__product-column global-product-combo__product-column--action">
                            <slot name="actionArea"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalTooltip from "@global/global-elements/global-tooltip/global-tooltip.vue";

export default {
    name: "global-product-combo",
    components: {GlobalTooltip},
    props: {
        product: null,
        isFirst: false,
        omitDecorColum: false,
        omitStructureColum: false,
        omitProductColum: false,
        omitApplicationColumn: false,
        omitRawboardColum: true,
    },
    methods: {
        composeAltText(parts = []) {
            let composedAlt = '';
            for (let part of parts) {
                if (part) {
                    composedAlt += part + ' '
                }
            }

            return composedAlt !== '' ? composedAlt : null
        },
        formatApplication(application) {
            return application.join(', ')
        }
    }
}
</script>
